import {
  Badge,
  Box,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Group,
  Input,
  MultiSelect,
  MultiSelectProps,
  rem,
  Select,
  Text,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import {
  useDebouncedCallback,
  useDebouncedValue,
  useDisclosure,
} from "@mantine/hooks";
import {
  IconBarcode,
  IconBriefcase,
  IconBuildingSkyscraper,
  IconBuildingWarehouse,
  IconFileExport,
  IconListDetails,
  IconPackage,
  IconSearch,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import {
  repositoryDelivery,
  repositoryPos,
  styleTableMantine,
} from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import LoadingOverlayCustom from "../../../common/LoadingOverLayCustom/LoadingOverLayCustom";
import { BASE_API_DELIVERY } from "../../../config";
import { _localization } from "../../../config/location";
import { green } from "../../../const/variables";
import { MessageResponse } from "../../../model/MessageResponse";
import { SelectListItemModel } from "../../../model/SelectListItem";
import { useLocation } from "react-router-dom";

const INVENTORY_TYPE_OPTIONS = [
  { value: "HB", label: "HB" },
  { value: "SR", label: "SR" },
  { value: "DA", label: "DA" },
  { value: "LR", label: "LR" },
];

interface SearchCriteria {
  keySearch?: string;
  branchIds?: string[];
  invCode?: string[];
  invTypes?: string[];
  itemCode?: string[];
  itemKey?: string;
  MaLoai?: string[];
  MaChung?: string[];
  MaNganh?: string[];
  MaLinhVuc?: string[];
  MaNhom?: string[];
}

type ColumnPinningType = {
  left?: string[];
  right?: string[];
};

type InventoryHbItem = {
  itemId: number;
  maSp: string;
  tenSp: string;
  maLoai: string | null;
  tenLoai: string | null;
  maChung: string | null;
  tenChung: string | null;
  maNhom: string | null;
  tenNhom: string | null;
  dvt: string | null;
  totalActualQty: number;
  totalVirtualQty: number;
  totalSellableQty?: number;
};

const InventoryReportHbList = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [isRefetching, setIsRefetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [visible, { toggle, close, open }] = useDisclosure(false);

  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [data, setData] = useState<InventoryHbItem[]>([]);
  const [dataBranchCode, setDataBranchCode] = useState<any[]>([]);
  const [dataInvCode, setDataInvCode] = useState<SelectListItemModel[]>([]);
  const [dataItemCode, setDataItemCode] = useState<SelectListItemModel[]>([]);
  const [dataCatSegment2b, setDataCatSegment2b] = useState<ComboboxItem[]>([]);
  const [dataCatSegment3c, setDataCatSegment3c] = useState<ComboboxItem[]>([]);
  const [dataCatSegment4d, setDataCatSegment4d] = useState<ComboboxItem[]>([]);
  const [rowCount, setRowCount] = useState(0);

  const [search, setSearch] = useState<SearchCriteria>({});
  const [search4d, setSearch4d] = useState<string>("");
  const [debounceSearch4d] = useDebouncedValue<string>(search4d, 500);

  const location = useLocation();

  const form = useForm<SearchCriteria>({
    mode: "uncontrolled",
    initialValues: {},
  });

  const columns = React.useMemo<MRT_ColumnDef<InventoryHbItem>[]>(
    () => [
      {
        header: "STT",
        accessorKey: "STT",
        enableColumnActions: false,
        enableSorting: false,
        enableResizing: false,
        Cell: ({ row }) => <>{row?.index + 1}</>,
        size: 50,
      },
      {
        accessorKey: "maSp",
        header: "Mã sản phẩm",
        Cell: ({ renderedCellValue }) => (
          <Badge
            radius="sm"
            variant="dot"
            size="md"
            style={{ cursor: "pointer" }}
            color={renderedCellValue === null ? "red" : green.base}
          >
            {renderedCellValue ?? "Không có mã sản phẩm"}
          </Badge>
        ),
      },
      {
        accessorKey: "tenSp",
        header: "Tên sản phẩm",
        size: 250,
      },
      {
        accessorKey: "maLoai",
        header: "Mã loại",
        size: 120,
      },
      {
        accessorKey: "tenLoai",
        header: "Tên loại",
        size: 150,
      },
      {
        accessorKey: "maChung",
        header: "Mã chủng",
        size: 120,
      },
      {
        accessorKey: "tenChung",
        header: "Tên chủng",
        size: 150,
      },
      {
        accessorKey: "maNhom",
        header: "Mã nhóm",
        size: 120,
      },
      {
        accessorKey: "tenNhom",
        header: "Tên nhóm",
        size: 150,
      },
      {
        accessorKey: "dvt",
        header: "Đơn vị tính",
        size: 120,
        footer: "Tổng:",
        Footer(props) {
          return (
            <div>
              <Text c="red" fw={800}>
                {props.column.columnDef.footer}
              </Text>
            </div>
          );
        },
      },
      {
        accessorKey: "totalActualQty",
        header: "Tổng tồn",
        size: 130,
        Footer: ({ table }: any) => {
          const total = table
            .getRowModel()
            .rows.reduce(
              (sum: number, row: any) =>
                sum + (row.original?.totalActualQty || 0),
              0
            );
          return (
            <div>
              <Text c="red" fw={800}>
                {total}
              </Text>
            </div>
          );
        },
      },
      {
        accessorKey: "totalSellableQty",
        header: "Tồn có thể bán",
        size: 130,
        Cell: ({ row }: any) => {
          const actual = row.original?.totalActualQty || 0;
          const virtual = row.original?.totalVirtualQty || 0;
          return <>{actual - virtual}</>;
        },
        Footer: ({ table }: any) => {
          const total = table
            .getRowModel()
            .rows.reduce(
              (sum: number, row: any) =>
                sum +
                ((row.original?.totalActualQty || 0) -
                  (row.original?.totalVirtualQty || 0)),
              0
            );
          return (
            <div>
              <Text c="red" fw={800}>
                {total}
              </Text>
            </div>
          );
        },
      },
    ],
    []
  );

  const renderMultiSelectOption: MultiSelectProps["renderOption"] = ({
    option,
  }) => (
    <Group gap="sm">
      <Text>{dataItemCode.find((x) => x.value === option.value)?.label}</Text>
    </Group>
  );

  const debouncedDataItemCode = useDebouncedCallback((value: string) => {
    if (value.length >= 3) {
      DataItemCode(value);
    }
  }, 500);

  const exportDataExcel = async () => {
    open();
    try {
      let url = `?Skip=${pagination?.pageIndex}&Take=${pagination.pageSize}`;
      const search = form.getValues();
      if (search.branchIds && search.branchIds.length > 0) {
        search.branchIds.forEach((branchId) => {
          url += `&BranchIds=${branchId}`;
        });
      }
      if (search.invCode && search.invCode.length > 0) {
        search.invCode.forEach((invCode) => {
          url += `&InvId=${invCode}`;
        });
      }
      if (search.invTypes && search.invTypes.length > 0) {
        search.invTypes.forEach((invType) => {
          url += `&InvTypes=${invType}`;
        });
      }
      if (search.itemCode && search.itemCode.length > 0) {
        search.itemCode.forEach((itemCode) => {
          url += `&ItemCode=${itemCode}`;
        });
      }
      if (search.keySearch) {
        url += `&KeySearch=${search.keySearch.trim().toLowerCase()}`;
      }
      if (search.itemKey) {
        url += `&itemKey=${search.itemKey.trim().toLowerCase()}`;
      }
      if (search.MaLoai && search.MaLoai.length > 0) {
        search.MaLoai.forEach((maLoai) => {
          url += `&MaLoais=${maLoai.trim().toLowerCase()}`;
        });
      }
      if (search.MaChung && search.MaChung.length > 0) {
        search.MaChung.forEach((maChung) => {
          url += `&MaChungs=${maChung.trim().toLowerCase()}`;
        });
      }
      if (search.MaNganh && search.MaNganh.length > 0) {
        search.MaNganh.forEach((maNganh) => {
          url += `&MaNganhs=${maNganh.trim().toLowerCase()}`;
        });
      }

      const baseUrl = `/api/v1/ExportExcel/export-inventory-report-hb${url}`;
      const _url = BASE_API_DELIVERY + baseUrl;
      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/vnd.ms-excel",
          Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
        },
      });

      if (!response.ok) {
        const errorResponse = await response.json();
        const errorMessage =
          errorResponse?.message || "Đã xảy ra lỗi khi xuất dữ liệu!";
        throw new Error(errorMessage);
      }

      const blob = await response.blob();
      const urlss = window.URL.createObjectURL(blob);
      let filename = "bao_cao_ton_kho_hang_ban.xlsx";
      const link = document.createElement("a");
      link.href = urlss;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(urlss);
    } catch (error: any) {
      console.log("error", error);
      NotificationExtension.Fails(
        error.message || "Đã xảy ra lỗi không xác định!"
      );
    } finally {
      close();
    }
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);

    let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
      pagination.pageSize
    }`;
    const search = form.getValues();

    if (search.branchIds && search.branchIds.length > 0) {
      search.branchIds.forEach((branchId) => {
        url += `&BranchIds=${branchId}`;
      });
    }
    if (search.invCode && search.invCode.length > 0) {
      search.invCode.forEach((invCode) => {
        url += `&InvId=${invCode}`;
      });
    }
    if (search.invTypes && search.invTypes.length > 0) {
      search.invTypes.forEach((invType) => {
        url += `&InvTypes=${invType}`;
      });
    }
    if (search.itemCode && search.itemCode.length > 0) {
      search.itemCode.forEach((itemCode) => {
        url += `&ItemCode=${itemCode}`;
      });
    }
    if (search.keySearch) {
      url += `&KeySearch=${search.keySearch.trim().toLowerCase()}`;
    }
    if (search.itemKey) {
      url += `&itemKey=${search.itemKey.trim().toLowerCase()}`;
    }
    if (search.MaLoai && search.MaLoai.length > 0) {
      search.MaLoai.forEach((maLoai) => {
        url += `&MaLoais=${maLoai.trim().toLowerCase()}`;
      });
    }
    if (search.MaChung && search.MaChung.length > 0) {
      search.MaChung.forEach((maChung) => {
        url += `&MaChungs=${maChung.trim().toLowerCase()}`;
      });
    }
    if (search.MaNganh && search.MaNganh.length > 0) {
      search.MaNganh.forEach((maNganh) => {
        url += `&MaNganhs=${maNganh.trim().toLowerCase()}`;
      });
    }

    try {
      const response = await repositoryDelivery.get(
        `/api/v1/TblInventorySerialOnhand/get-list-inventory-hb${url}`
      );
      if (response && response.success) {
        let result = response.data;
        setData(result);
        setRowCount(response.totalCount);
        table.resetRowSelection();
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };

  const DataBrachCode = async () => {
    try {
      const response = await repositoryPos.get(
        `api/v1/TblDmInventory/get-select-branch?auth=true`
      );
      if (response && response.success) {
        const transformedData = response.data
          .filter((i: any) => i.value && i.value !== "-1" && i.text)
          .map((item: any) => {
            return {
              value: String(item.value),
              label: item.att2 ? `${item.att2} - ${item.text}` : item.text,
              id: item.value,
            };
          });

        setDataBranchCode(transformedData);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };

  const getCatSegment2b = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblCatSegment2b/get-all"
    );

    if (res && res.success) {
      let data: ComboboxItem[] = [];
      if (search?.MaLinhVuc && search?.MaLinhVuc?.length > 0) {
        data = res.data
          ?.filter(
            (item: any) =>
              item.codeString &&
              item.name &&
              item.segment1CodeString === search?.MaLinhVuc
          )
          ?.map((item: any) => ({
            label: `${item.codeString} - ${item.name}`,
            value: item.codeString?.toString(),
          }));
      } else {
        data = res.data
          ?.filter((item: any) => item.codeString && item.name)
          ?.map((item: any) => ({
            label: `${item.codeString} - ${item.name}`,
            value: item.codeString?.toString(),
          }));
      }

      setDataCatSegment2b(data);
    }
  };

  const getCatSegment3c = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblCatSegment3c/get-all"
    );

    if (res && res.success) {
      let data: ComboboxItem[] = [];
      if (search?.MaNganh && search?.MaNganh.length > 0) {
        data = res.data
          ?.filter(
            (item: any) =>
              item.codeString &&
              item.name &&
              item.segment2CodeString === search?.MaNganh
          )
          ?.map((item: any) => ({
            label: `${item.codeString} - ${item.name}`,
            value: item.codeString?.toString(),
          }));
      } else {
        data = res.data
          ?.filter((item: any) => item.codeString && item.name)
          ?.map((item: any) => ({
            label: `${item.codeString} - ${item.name}`,
            value: item.codeString?.toString(),
          }));
      }

      setDataCatSegment3c(data);
    }
  };

  const getCatSegment4d = async () => {
    let url = `/api/v1/TblCatSegment4d/get-list?Skip=0&Take=50`;

    if (search?.MaLoai && search?.MaLoai?.length > 0) {
      url += `&listCodeSegmentString3=${search?.MaLoai}`;
    }

    if (debounceSearch4d.length > 3 && search?.MaChung?.length === 0) {
      url += `&KeySearch=${debounceSearch4d}`;
    } else {
      url += `&KeySearch=${debounceSearch4d?.split(" - ")[0]}`;
    }

    const res = await repositoryPos.get<MessageResponse<any>>(url);

    if (res && res.success) {
      const data = res.data
        ?.filter((item: any) => item.codeString && item.name)
        ?.map((item: any) => ({
          label: `${item.codeString} - ${item.name}`,
          value: item.codeString?.toString(),
        }));

      setDataCatSegment4d(data);
    }
  };

  const DataInvCode = async () => {
    try {
      const response = await repositoryPos.get(
        `/api/v1/TblDmInventory/get-all?checkAuth=true&select=true`
      );
      if (response && response.success) {
        const transformedData = response.data
          ?.filter((i: any) => i.value && i.text && i.value !== "-1")
          ?.map((item: any) => ({
            label: item.text?.toString(),
            value: String(item.att2),
          }));

        setDataInvCode(transformedData);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };

  const DataItemCode = async (keySearch: string) => {
    try {
      let url = "";
      if (keySearch && keySearch.length > 0) {
        url += `&ItemCodes=${keySearch}`;
      }
      const response = await repositoryPos.get(
        `/api/v1/TblItem/get-select?Key=${keySearch}&Page=30`
      );
      if (response && response.success) {
        const transformedData = response.data
          ?.filter((i: any) => i.value && i.text)
          .map((branch: any) => ({
            value: branch.value,
            label: branch.text,
          }));
        const uniqueData = Array.from(
          new Set(transformedData.map((item: any) => item.value))
        ).map((value) =>
          transformedData.find((item: any) => item.value === value)
        );
        setDataItemCode(uniqueData);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    rowCount,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    enableStickyFooter: true,
    state: {
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    onPaginationChange: setPagination,
    positionToolbarAlertBanner: "bottom",
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["STT", "maSp"],
        right: ["totalSellableQty"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (165 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);

  useEffect(() => {
    fetchData();
  }, [pagination]);

  useEffect(() => {
    DataBrachCode();
    DataInvCode();
    getCatSegment2b();
  }, []);

  return (
    <Box>
      <LoadingOverlayCustom visible={visible} />
      <div
        style={{ border: "1px solid #dee2e6", padding: "10px" }}
        ref={headerRef}
      >
        <Group justify="space-between" gap={0}>
          <_breadcrumb></_breadcrumb>
          <Flex direction="row" gap={10}>
            <Button
              leftSection={
                <IconFileExport style={{ width: rem(14), height: rem(14) }} />
              }
              onClick={() => exportDataExcel()}
            >
              Export Excel
            </Button>
          </Flex>
        </Group>

        <Grid mt={10}>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <Input
              placeholder="Nhập từ khóa tìm kiếm..."
              key={form.key("keySearch")}
              type="text"
              leftSection={<IconSearch size={"20"} color="#15aabf" />}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  await fetchData();
                }
              }}
              {...form.getInputProps("keySearch")}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <Input
              placeholder="Mã sản phẩm"
              key={form.key("itemKey")}
              type="text"
              leftSection={<IconSearch size={"20"} color="#15aabf" />}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  await fetchData();
                }
              }}
              {...form.getInputProps("itemKey")}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <MultiSelect
              key={form.key("branchIds")}
              size="sm"
              placeholder="Chi nhánh"
              searchable
              clearable
              data={dataBranchCode?.map((item) => ({
                label: item.label,
                value: item.value,
              }))}
              leftSection={<IconBuildingSkyscraper size={20} color="#15aabf" />}
              onClick={() => {
                if (dataBranchCode.length === 0) {
                  DataBrachCode();
                }
              }}
              {...form.getInputProps("branchIds")}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <MultiSelect
              key={form.key("invCode")}
              size="sm"
              placeholder="Kho hàng"
              searchable
              clearable
              data={dataInvCode}
              leftSection={<IconBuildingWarehouse size={20} color="#15aabf" />}
              onClick={() => {
                if (dataInvCode.length === 0) {
                  DataInvCode();
                }
              }}
              {...form.getInputProps("invCode")}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <MultiSelect
              key={form.key("invTypes")}
              size="sm"
              placeholder="Loại kho (HB, SR, DA, LR)"
              searchable
              clearable
              data={INVENTORY_TYPE_OPTIONS}
              leftSection={<IconListDetails size={20} color="#15aabf" />}
              {...form.getInputProps("invTypes")}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <MultiSelect
              key={form.key("itemCode")}
              size="sm"
              placeholder="Mã sản phẩm"
              searchable
              clearable
              data={dataItemCode.map((x) => x.value)}
              renderOption={renderMultiSelectOption}
              leftSection={<IconBarcode size={20} color="#15aabf" />}
              onSearchChange={(value) => {
                debouncedDataItemCode(value);
              }}
              {...form.getInputProps("itemCode")}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <Select
              key={form.key("MaLinhVuc")}
              size="sm"
              placeholder="Lĩnh vực"
              searchable
              clearable
              data={[
                { value: "01", label: "01 - Hi-End / Studio" },
                { value: "02", label: "02 - IT / DV" },
              ]}
              leftSection={<IconBriefcase size={20} color="#15aabf" />}
              {...form.getInputProps("MaLinhVuc")}
              onChange={(value) => {
                form.setFieldValue("MaLinhVuc", value ? [value] : []);
                getCatSegment2b();
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <MultiSelect
              key={form.key("MaNganh")}
              size="sm"
              placeholder="Ngành"
              searchable
              clearable
              data={dataCatSegment2b}
              leftSection={<IconListDetails size={20} color="#15aabf" />}
              onClick={() => {
                if (dataCatSegment2b.length === 0) {
                  getCatSegment2b();
                }
              }}
              {...form.getInputProps("MaNganh")}
              onChange={(value) => {
                form.setFieldValue("MaNganh", value);
                getCatSegment3c();
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <MultiSelect
              key={form.key("MaLoai")}
              size="sm"
              placeholder="Loại"
              searchable
              clearable
              data={dataCatSegment3c}
              leftSection={<IconPackage size={20} color="#15aabf" />}
              onClick={() => {
                if (dataCatSegment3c.length === 0) {
                  getCatSegment3c();
                }
              }}
              {...form.getInputProps("MaLoai")}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <MultiSelect
              key={form.key("MaChung")}
              size="sm"
              placeholder="Chủng loại"
              searchable
              clearable
              data={dataCatSegment4d}
              leftSection={<IconPackage size={20} color="#15aabf" />}
              onSearchChange={(value) => {
                setSearch4d(value);
              }}
              onClick={() => {
                if (dataCatSegment4d.length === 0) {
                  getCatSegment4d();
                }
              }}
              {...form.getInputProps("MaChung")}
            />
          </Grid.Col>

          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <Flex gap={10}>
              <Button
                leftSection={<IconSearch size={16} />}
                onClick={() => fetchData()}
              >
                Tìm kiếm
              </Button>
              <Button
                variant="outline"
                color="gray"
                onClick={() => {
                  form.reset();
                  fetchData();
                }}
              >
                Đặt lại
              </Button>
            </Flex>
          </Grid.Col>
        </Grid>
      </div>

      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </Box>
  );
};

export default InventoryReportHbList;
